import './ProfileSteps.scss';

import siteMessages from '../../pages/root/siteMessages';
import { useIntl } from 'react-intl';

interface Props {
  step: number;
  steps: number;
  image: any;
}

const ProfileSteps = ({ step, steps, image }: Props) => {
  const intl = useIntl();

  return (
    <div className="profile-steps">
      <h3>
        {intl.formatMessage({ ...siteMessages.step })} {step}/{steps}
      </h3>
      <img src={image} width="auto" alt="" className="profile-steps-image" />
    </div>
  );
};

export default ProfileSteps;
